export default "__VITE_ASSET__623ccfd5__"